import { AWARDS, CERTIFICATES, CERTIFICATE_TEMPLATES } from "../../routes";
import type { CreateCrumb } from "../CreateNotice/CreateSectionHeader";

export const CERTIFICATES_CRUMB: CreateCrumb = { label: "Certificates", to: CERTIFICATES };
export const CERTIFICATE_TEMPLATES_CRUMB: CreateCrumb = {
  label: "Templates",
  to: CERTIFICATE_TEMPLATES,
};
export const AWARDS_CRUMB: CreateCrumb = { label: "Awards", to: AWARDS };
